/**
 * macOS テーマ適用判定のデフォルト除外パス
 *
 * 抽象（`shouldApplyMacOsTheme`）から個別 feature 名のハードコードを切り離し、
 * 「テーマを適用しない feature path 一覧」をデータとして本ファイルに集約する。
 *
 * 設計方針:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 * - 各 feature が増減する際はここを 1 行追加するだけで済む
 * - 将来は各 feature の `route-config.ts` から `themeExclude` を集約する形に
 *   発展可能（L-A3 の route-registry と同パターン）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-B5
 */

/**
 * テーマ適用しない feature の prefix（前方一致）。
 * セグメント境界（末尾スラッシュ）で区切られる前提。
 */
export const DEFAULT_THEME_EXCLUDE_PREFIXES: readonly string[] = [
  '/customer-portal/',  // マイページ（お客様向け）
  '/g-plans/',          // G-PLAN（ユーザー指定除外）
  '/ICpochipochi/catalog/', // ICぽちぽち カタログ側（お客様向け）
  '/ICpochipochi/portal/',  // ICぽちぽち ポータル側（お客様向け）
  '/ICpochipochi/browse/',  // ICぽちぽち ブラウズ側（お客様向け）
  '/open/',             // 公開ページ
] as const

/**
 * テーマ適用しないパス（完全一致）。
 * 上記 prefix の先頭セグメントそのものと、認証フロー関連を含む。
 */
export const DEFAULT_THEME_EXCLUDE_EXACT: readonly string[] = [
  '/customer-portal',
  '/g-plans',
  '/ICpochipochi/catalog',
  '/ICpochipochi/portal',
  '/ICpochipochi/browse',
  '/open',
  '/login',
] as const
